export const SET_TIPO_ARQUIVO = 'SET_TIPO_ARQUIVO';
export const LOADING_TIPO_ARQUIVO = 'LOADING_TIPO_ARQUIVO';
export const SET_LISTA_POR_CATEGORIA = 'SET_LISTA_POR_CATEGORIA';